import { Injectable, NgModule } from '@angular/core';
import { Subject, BehaviorSubject } from 'rxjs';
//import { LocalApiConnectorService } from './local-api-connector.service';

@Injectable()
export class DataTransferService {

  public printers = new BehaviorSubject([]);
  public getPrinters() {
    // this.agent.getPrinters((res) => {
    //   this.printers.next(this.toArray(res));
    // }, () => { this.printers.next(["Microsoft Print to PDF"]) });
    // return this.printers.asObservable();
  }

  private companySource = new Subject();
  private branchSource = new Subject();
  private userSource = new Subject();
  private shipmentSource = new Subject();

  private modeSource = new BehaviorSubject('default message');
  currentmode = this.modeSource.asObservable();
  changeMode(message: string) {
    this.modeSource.next(message)
  }

  private productGroupSource = new BehaviorSubject('default message');
  currentProductGroupSource = this.productGroupSource.asObservable();
  changeProductGroup(message: string) {
    this.productGroupSource.next(message)
  }

  private productTypeSource = new BehaviorSubject('default message');
  currentProductTypeSource = this.productTypeSource.asObservable();
  changeProductType(message: string) {
    this.productTypeSource.next(message)
  }am

  private countrySource = new BehaviorSubject('default message');
  countryTypeSource = this.countrySource.asObservable();
  changeCountry(message: string) {
    this.countrySource.next(message)
  }

  currentCompany = this.companySource.asObservable();
  currentBranch = this.branchSource.asObservable();
  currentUser = this.userSource.asObservable();
  currentShipment = this.shipmentSource.asObservable();

  setCompany(company) {
    this.companySource.next(company);
    sessionStorage.setItem("company", JSON.stringify(company));
  }
  
  setSelectedBranch(branch) {
    this.branchSource.next(branch);
    sessionStorage.setItem("branch", JSON.stringify(branch));
  }

  setUser(user) {
    this.userSource.next(user);
    sessionStorage.setItem("user", JSON.stringify(user));
  }
  setShipment(Shipment) {
    this.shipmentSource.next(Shipment);
  }

  toArray(obj) {
    var arr = [];
    for (var x in obj) if (obj.hasOwnProperty(x)) {
      arr.push(obj[x]);
    }
    return arr;
  }
 //constructor(private agent: LocalApiConnectorService) { }
}








